import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { SubscribeService } from 'src/app/core/services/subscribe/subscribe.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  public subscriptionForm : FormGroup;
  constructor(private toastr: ToastrService,
    private subscriptionService: SubscribeService) { 
    this.subscriptionForm = new FormGroup({
      email: new FormControl(null, Validators.required),
    });
  }

  ngOnInit(): void {
  }


  async subscribe(){
    const {email} = this.subscriptionForm.value;
    if(email == "" || email == undefined || email == null)
    {
      this.toastr.error("Email cannot be empty", "Subscription");
    }
    else{
      await this.subscriptionService.subscribe(email);
      this.toastr.success("Thanks for reaching us, our team will get back to you soon", "Subscription");
    }
      
  }
}
